{
  "Sidebar": {
    "badges": {
      "beta": "Beta"
    },
    "guest": {
      "title": "Seu trabalho fica salvo apenas temporariamente",
      "description": "Como convidado, você não poderá mais acessar suas provas, chats e arquivos depois de fechar esta aba; eles são excluídos no máximo 24 horas após sua última atividade. Entre gratuitamente para salvá-los permanentemente.",
      "loginButton": "Entrar agora"
    },
    "actions": {
      "newExamTitle": "Criar nova prova",
      "creating": "Criando...",
      "newExam": "Nova prova"
    },
    "examList": {
      "title": "Minhas provas",
      "noExams": "Nenhuma prova encontrada.",
      "unnamed": "Sem nome",
      "unnamedExam": "Prova sem nome",
      "loadOlder": "Carregar provas mais antigas"
    },
    "examMenu": {
      "edit": "Editar",
      "addToClass": "Adicionar à turma",
      "delete": "Excluir"
    },
    "bottomNav": {
      "profile": "Perfil",
      "settings": "Configurações",
      "feedback": "Enviar feedback"
    },
    "dialogs": {
      "renameTitle": "Editar prova",
      "groupTitle": "Agrupar prova",
      "renameDesc": "Edite as informações da prova.",
      "groupDesc": "Selecione uma turma ou grupo para esta prova.",
      "fields": {
        "name": "Nome",
        "subject": "Disciplina",
        "topic": "Tema",
        "class": "Turma",
        "placeholderSelect": "Por favor, selecione..."
      },
      "save": "Salvar"
    },
    "alerts": {
      "saveFailed": "Falha ao salvar"
    },
    "deleteDialog": {
      "title": "Excluir prova?",
      "body": "A prova será excluída permanentemente junto com o chat, todas as entregas e arquivos.",
      "keepReleases": "Manter os resultados liberados para os alunos",
      "keepReleasesDesc_one": "1 aluno continua vendo seu resultado. Se desmarcar, ele também será excluído.",
      "keepReleasesDesc_other": "{{count}} alunos continuam vendo seus resultados. Se desmarcar, esses resultados também serão excluídos.",
      "keepReleasesDescUnknown": "Todos os resultados liberados continuam visíveis para os alunos. Se desmarcar, eles também serão excluídos.",
      "cancel": "Cancelar",
      "confirm": "Excluir"
    }
  },
  "Settings": {
    "title": "Configurações",
    "soon": "Em breve",
    "DisplayAndLanguage": {
      "title": "Exibição e Idioma",
      "languageLabel": "Idioma",
      "languageDesc": "Escolha o idioma da interface do usuário.",
      "themeLabel": "Aparência",
      "themeDesc": "Alterne entre os modos claro e escuro."
    },
    "AI": {
      "title": "IA e Avaliação",
      "strictnessLabel": "Incerteza da IA",
      "strictnessDesc": "Determina em qual nível de confiança da IA a revisão manual é obrigatória.",
      "strictnessWarning": "Aviso: Com \"Alta Autonomia\", você só intervém manualmente quando a IA está muito incerta...",
      "gradingKindnessLabel": "Rigor da Avaliação",
      "gradingKindnessDesc": "Determina com que rigor a IA aplica o esquema de avaliação. Tolerante favorece o aluno em casos limítrofes; Rigoroso segue o esquema exatamente.",
      "gradingKindnessOptions": {
        "lenient": "Tolerante",
        "balanced": "Equilibrado",
        "strict": "Rigoroso"
      }
    },
    "Notifications": {
      "title": "Notificações",
      "soon": "Em breve",
      "emailLabel": "Notificações por e-mail",
      "emailDesc": "Receba notificações por e-mail sobre eventos importantes",
      "browserLabel": "Notificações do navegador",
      "browserDesc": "Receba notificações push diretamente no seu navegador"
    },
    "About": {
      "title": "Sobre o Gradias",
      "landingPage": "Visitar gradias.ai",
      "support": "Ajuda e Suporte",
      "imprint": "Aviso Legal",
      "privacy": "Política de Privacidade"
    },
    "Account": {
      "title": "Dados e Conta",
      "exportLabel": "Exportar meus dados",
      "exportDesc": "Baixe todas as provas enviadas e resultados como um arquivo ZIP",
      "deleteLabel": "Excluir conta",
      "deleteDesc": "Excluir definitivamente sua conta e seus dados",
      "deleteDialogTitle": "Excluir conta?",
      "deleteDialogBody": "Enviaremos um link de confirmação para o seu e-mail. Sua conta só é excluída por meio desse link – junto com suas provas de prática, chats, arquivos, participações em turmas e os resultados liberados para você. Trabalhos entregues na prova de um professor ficam com o professor.",
      "deleteDialogSent": "Enviamos um link para você. Abra-o dentro de uma hora para confirmar a exclusão.",
      "deleteDialogError": "Ocorreu um problema. Tente novamente mais tarde.",
      "deleteDialogCancel": "Cancelar",
      "deleteDialogConfirm": "Enviar link de confirmação",
      "deleteDialogClose": "Fechar",
      "deleteDialogBodyTeacher": "Enviaremos um link de confirmação para o seu e-mail. Sua conta só é excluída por meio desse link – com todas as suas turmas, provas, entregas, chats e arquivos. Seus alunos perdem a turma e todos os resultados liberados para eles; as contas deles continuam existindo. Avise-os antes, por favor.",
      "deleteDialogImpactTeacher": "Turmas: {{classes}} · Provas: {{exams}} · Alunos afetados: {{students}}",
      "deleteDialogBlockedAdmin": "Contas de administrador não podem ser excluídas aqui. A conta precisa primeiro ser removida de ADMIN_USER_IDS.",
      "deleteDialogBlockedImpersonating": "Esta conta não pode ser excluída enquanto você estiver conectado como outro usuário."
    }
  },
  "Profile": {
    "title": "Perfil",
    "actions": {
      "cancel": "Cancelar",
      "save": "Salvar",
      "edit": "Editar"
    },
    "alerts": {
      "saveError": "Não foi possível salvar o perfil.",
      "generalError": "Ocorreu um erro."
    },
    "personal": {
      "firstName": "Nome",
      "lastName": "Sobrenome",
      "name": "Nome",
      "school": "Escola",
      "noSchool": "Nenhuma escola informada",
      "email": "E-mail",
      "emailHint": "O e-mail não pode ser alterado aqui.",
      "defaultUser": "Usuário",
      "role": {
        "teacher": "Professor(a)",
        "student": "Aluno(a)"
      }
    },
    "teaching": {
      "subjects": "Minhas disciplinas",
      "noSubjects": "Nenhuma disciplina informada"
    },
    "rules": {
      "title": "Regras e Preferências",
      "description": "Preferências salvas que o assistente segue – ao conversar, avaliar e criar soluções-modelo e critérios de avaliação. Você mesmo pode editá-las aqui, mas o assistente também pode ajustá-las diretamente no chat, se solicitado.",
      "general": "Geral",
      "empty": "Nenhuma regra salva ainda.",
      "addRule": "Adicionar regra",
      "removeRule": "Remover regra",
      "limitReached": "Limite atingido",
      "limitHint": "Máximo de {{max}} regras por categoria",
      "placeholder": "Descreva a regra...",
      "categories": {
        "chat_and_workflow": "Chat e Fluxo de Trabalho",
        "grading_and_feedback": "Avaliação e Feedback",
        "master_solution_design": "Soluções-modelo",
        "grading_scheme_creation": "Critérios de avaliação"
      },
      "categoryDescs": {
        "chat_and_workflow": "Como o assistente responde no chat e gerencia o fluxo de trabalho",
        "grading_and_feedback": "Como as respostas são avaliadas e como o feedback é formulado",
        "master_solution_design": "Como as soluções-modelo são criadas",
        "grading_scheme_creation": "Como os critérios de avaliação são estruturados"
      },
      "grammar": {
        "alwaysUseFi": "Usar sempre o índice de erros (FI)",
        "alwaysUseFiDesc": "Por predefinição, usa o índice de erros em vez de quaisquer regras de gramática detetadas num esquema de avaliação carregado. Pode ser substituído por exame.",
        "languageUseRegradeWordCutoff": "Reavaliar automaticamente o domínio da língua a partir de (palavras)",
        "languageUseRegradeWordCutoffDesc": "Ao editar a resposta de um aluno, o domínio da língua do grupo afetado é reavaliado automaticamente assim que pelo menos esse número de palavras tiver sido alterado (várias pequenas edições se somam).",
        "contentRegradeWordCutoff": "Reavaliar automaticamente o conteúdo a partir de (palavras)",
        "contentRegradeWordCutoffDesc": "0 = sempre (padrão) — o conteúdo é reavaliado imediatamente a cada alteração de texto. Um valor mais alto ignora a reavaliação automática para alterações muito pequenas."
      }
    },
    "security": {
      "title": "Conta e Segurança",
      "changePassword": "Alterar senha",
      "changePasswordDesc": "Gerenciar a segurança da sua conta",
      "changePasswordSent": "Enviamos um link por e-mail para você alterar sua senha.",
      "changePasswordError": "Houve um problema. Por favor, tente novamente mais tarde.",
      "changePasswordConfirmTitle": "Alterar a senha?",
      "changePasswordConfirmDesc": "Enviaremos um link para {{email}}. Se você usá-lo e definir uma nova senha, sua sessão será encerrada em todos os outros dispositivos.",
      "changePasswordSend": "Enviar link",
      "changePasswordCancel": "Cancelar",
      "changePasswordClose": "Fechar",
      "logout": "Sair",
      "logoutDesc": "Sair deste dispositivo com segurança"
    },
    "badges": {
      "soon": "Em breve"
    }
  },
  "ClassInsights": {
    "overview": "Visão geral",
    "examCount": "Provas",
    "subjectCount": "Disciplinas",
    "gradedCount": "Corrigidas",
    "examListTitle": "Provas nesta turma",
    "noExams": "Ainda não há provas nesta turma.",
    "loading": "Carregando estatísticas …",
    "statusGraded": "Corrigida",
    "statusInProgress": "Em andamento",
    "unnamedExam": "Prova sem nome",
    "unknownSubject": "Disciplina desconhecida"
  },
  "Dashboard": {
    "guestMessage": "Eu sou o gradi, seu assistente de correção de provas com IA.",
    "greetings": {
      "opt1": "Quais provas vamos corrigir hoje?",
      "opt2": "Vamos dar conta dessa pilha de provas.",
      "opt3": "O que temos para hoje?",
      "opt4": "Como posso ajudar você hoje?",
      "opt5": "Que bom que você está aqui. Por onde começamos?",
      "opt6": "Vamos começar a corrigir!"
    },
    "studentGreetings": {
      "opt1": "O que vamos aprender hoje?",
      "opt2": "Vamos encarar algumas questões de prova?",
      "opt3": "O que temos para hoje?",
      "opt4": "Como posso ajudar você hoje?",
      "opt5": "Que bom que você está aqui. Por onde começamos?",
      "opt6": "Vamos começar!"
    },
    "fallbackGreeting": "O que temos para hoje?",
    "greetingPrefix": "Oi",
    "inputPlaceholder": "Faça uma pergunta...",
    "dropzoneText": "Solte os arquivos aqui",
    "actions": {
      "startGrading": {
        "label": "Iniciar correção de provas",
        "prompt": "Quero iniciar uma nova correção de provas. Por favor, guie-me passo a passo pelo processo, desde o upload até os critérios de avaliação."
      },
      "uploadExam": {
        "label": "Enviar minha prova",
        "prompt": "Quero enviar uma prova que já fiz para que você a corrija para mim. Como começamos?"
      },
      "createExam": {
        "label": "Criar um simulado",
        "prompt": "Quero criar um novo simulado. Você pode me ajudar a montar um?"
      },
      "howItWorks": {
        "label": "Como o gradias funciona?",
        "prompt": "Por favor, explique-me de forma breve e concisa como o gradias funciona e quais etapas preciso seguir para uma correção bem-sucedida."
      },
      "sampleData": {
        "label": "Testar com dados de exemplo",
        "prompt": "Quero testar o sistema, mas não tenho nenhuma prova minha em mãos. Como posso testar usando uma prova de exemplo?"
      },
      "taskTypes": {
        "label": "Quais tipos de questões estão disponíveis?",
        "prompt": "Que tipos de questões (por exemplo, texto livre, múltipla escolha, equações matemáticas) você consegue corrigir atualmente?"
      },
      "privacy": {
        "label": "Privacidade e Segurança",
        "prompt": "Como o gradias lida com a privacidade de dados? O que acontece com as provas enviadas dos meus alunos?"
      }
    },
    "alerts": {
      "uploadError": "Erro ao enviar o arquivo",
      "noExamId": "Nenhum examId presente"
    },
    "aria": {
      "uploadFiles": "Enviar arquivos",
      "submit": "Enviar",
      "removeFile": "Remover arquivo"
    }
  },
  "ChatInput": {
    "statusLabels": {
      "allComplete": "Todas as etapas concluídas",
      "configRunning": "Pronto - Preparado para continuar",
      "readyForConfig": "Pronto para configuração",
      "status": "Status",
      "progress": "Progresso",
      "inProgress": "em andamento"
    },
    "steps": {
      "examCreator": {
        "label": "Criar prova",
        "phasePlan": "Planejando a prova",
        "phaseMaterial": "Gerando figuras",
        "phaseSource": "Redigindo as tarefas",
        "phaseRepair": "Finalizando o documento"
      },
      "upload": {
        "label": "Upload de arquivos"
      },
      "studentAssignment": {
        "label": "Atribuição de alunos",
        "activeWait": "Aguardando confirmação",
        "activeAssign": "Atribuir entregas dos alunos"
      },
      "structure": {
        "label": "Estrutura da prova",
        "active": "Detectando questões"
      },
      "answers": {
        "label": "Respostas dos alunos",
        "active": "Processando respostas"
      },
      "masterSolution": {
        "label": "Solução-modelo",
        "activeDetect": "Detectando solução-modelo",
        "activeCreate": "Criando solução-modelo",
        "activeComplete": "A completar a solução modelo"
      },
      "gradingScheme": {
        "label": "Critérios de avaliação",
        "activeDetect": "Detectando critérios de avaliação",
        "activeCreate": "Criando critérios de avaliação",
        "activeComplete": "A completar os critérios de avaliação"
      },
      "grading": {
        "label": "Correção",
        "active": "Correção em andamento"
      },
      "summary": {
        "label": "Resumo dos resultados"
      }
    },
    "badges": {
      "uncertainties": "Incertezas",
      "errorRegions": "Regiões com erro",
      "errorSubmissions": "Entregas com erro",
      "documentEncrypted": "Documento criptografado"
    },
    "ui": {
      "showProgress": "Exibir progresso da correção",
      "dropFilesHere": "Solte os arquivos aqui",
      "uploadFiles": "Enviar arquivos",
      "waitUpload": "Aguarde o upload",
      "sendMessage": "Enviar mensagem",
      "privacyNotice": "100% em conformidade com o RGPD. Seus dados e documentos dos alunos não serão utilizados para treinamento de IA.",
      "learnMore": "Saiba mais."
    },
    "alerts": {
      "uploadError": "Erro ao enviar o arquivo",
      "noExamId": "Nenhum examId presente"
    }
  },
  "TokenInput": {
    "placeholder": "Faça uma pergunta..."
  },
  "Chat": {
    "auth": {
      "login": "Entrar",
      "register": "Cadastrar"
    },
    "loading": {
      "masterSolutions": "Carregando soluções-modelo...",
      "examData": "Carregando dados da prova e imagens...",
      "extractingTasks": "Extraindo questões... {{finished}}/{{total}}",
      "splitThinkingMessage": "Estou organizando as entregas dos alunos",
      "structureThinkingMessage": "Estou detectando a estrutura da prova",
      "examStructure": "Carregando estrutura da prova...",
      "pages": "Carregando páginas...",
      "summary": "Carregando resumo..."
    },
    "alerts": {
      "errorOccurred": "Desculpe, ocorreu um erro. Por favor, tente novamente mais tarde.",
      "reportsBlocked": "Os relatórios em PDF estarão disponíveis apenas quando todas as questões principais forem aprovadas ou se houver uma confiança da IA superior a {{threshold}}%.",
      "noSubmissionsForReports": "Nenhuma entrega com dados de relatório encontrada.",
      "reportsFailed": "Não foi possível gerar os relatórios em PDF. Por favor, tente novamente."
    },
    "sampleExamIntro": "Gostaria de corrigir esta prova com os seguintes documentos:\n{{lines}}",
    "canvasTitles": {
      "boundingbox": "Ajustar áreas das questões",
      "msedit": "Editar solução-modelo / critérios de avaliação",
      "correction": "Correção",
      "summary": "Resumo da correção",
      "structureeditor": "Editar estrutura da prova",
      "submissioncheck": "Verificar atribuição de páginas",
      "demoselector": "Selecionar demonstração",
      "examcreator": "Criar prova",
      "legal": "Legal Navigator (jurídico e regulatório)",
      "default": "Visualização detalhada"
    },
    "legalNavigator": {
      "title": "Conteúdo externo: app do ChatGPT da OpenAI",
      "notice": "O Legal Navigator é um app do ChatGPT da OpenAI. Ao carregá-lo, seu endereço IP e os dados do seu navegador são enviados à OpenAI, possivelmente também para os EUA.",
      "noStudentData": "Por favor, não insira lá dados pessoais de alunos.",
      "privacyLink": "Política de privacidade da OpenAI",
      "load": "Carregar conteúdo"
    }
  },
  "Canvas": {
    "common": {
      "resize": "Ajustar tamanho",
      "toSummaryTitle": "Para o resumo",
      "backToSummary1": "Voltar para o",
      "backToSummary2": "Resumo",
      "restore": "Restaurar",
      "fullscreen": "Tela cheia",
      "close": "Fechar"
    },
    "grading": {
      "prevTask": "Questão anterior",
      "nextTask": "Próxima questão",
      "taskXofY": "Questão {{current}} de {{total}}",
      "taskName": "Questão {{number}}",
      "nextUncertainty": "Próxima incerteza ({{count}})",
      "uncertaintiesLeft": "Restam {{count}} incertezas",
      "backToSummary1": "Voltar para o",
      "backToSummary2": "Resumo",
      "submissionX": "Entrega {{id}}",
      "pages": "Páginas:",
      "pageX": "Página {{page}}",
      "addBoundingBox": "Adicionar nova caixa delimitadora",
      "extractedText": "Texto extraído",
      "verified": "Verificado",
      "consistencyAdjusted": "Ajustado automaticamente para consistência com outras submissões",
      "bboxConfidence": "Confiança da BBox: {{conf}}%",
      "review": "Revisar",
      "noTextExtracted": "Nenhum texto extraído.",
      "imageContent": "Imagem (sem reconhecimento de texto) - o recorte de imagem detectado será usado diretamente para processamento posterior",
      "aiGrading": "Avaliação da IA",
      "pts": "Pts.",
      "points": "Pontos:",
      "noGradingYet": "Nenhuma avaliação disponível ainda.",
      "gradingScheme": "Critérios de avaliação",
      "expand": "Expandir",
      "collapse": "Recolher",
      "maxPoints": "Pontos máx.: {{points}}",
      "noGradingSchemeYet": "Nenhum critério de avaliação disponível ainda.",
      "boxModeContent": "Conteúdo",
      "boxModeLanguageUse": "Domínio da língua",
      "groupLanguageUseRule": "Grupo: tarefa {{tasks}}",
      "groupLanguageUseRuleNumbered": "Grupo {{number}}: tarefa {{tasks}}",
      "editLanguageUseGroupTasks": "Editar tarefas deste grupo",
      "deleteLanguageUseGroup": "Excluir esta regra de domínio da língua",
      "deleteLanguageUseGroupConfirm": "Excluir esta regra de domínio da língua? Esta ação não pode ser desfeita.",
      "deleteLanguageUseGroupBlocked": "Não é possível excluir enquanto a correção está em andamento.",
      "languageUseGroupPickerInfo": "Marque uma tarefa para adicioná-la a este grupo. Desmarque para removê-la; se ainda precisar da própria regra de domínio da língua, ela é preenchida com o texto deste grupo e 0 pontos para você encontrá-la novamente.",
      "languageUseGroupPickerSaveFailed": "Falha ao salvar. Tente novamente.",
      "languageUseGroupPickerEmptyDraft": "Uma regra precisa de pelo menos uma tarefa.",
      "deleteBox": "Excluir caixa delimitadora",
      "retryOcr": "Repetir reconhecimento de texto",
      "unlockBox": "Desbloquear caixa delimitadora",
      "lockBox": "Bloquear caixa delimitadora",
      "noSubmissionsFound": "Nenhuma entrega encontrada.",
      "examPageX": "Página da prova {{page}}",
      "rerunningOcr": "Repetindo o reconhecimento de texto...",
      "regrading": "Reavaliando...",
      "regradingQueued": "Na fila..."
    },
    "msgs": {
      "noTasksFound": "Nenhuma questão encontrada.",
      "prevTask": "Questão anterior",
      "nextTask": "Próxima questão",
      "task": "Questão",
      "taskMain": "Questão {{main}}",
      "taskSub": "Questão {{main}}.{{sub}}",
      "uncertaintiesLeft": "Restam {{count}} incertezas",
      "nextUncertainty": "Próxima incerteza ({{count}})",
      "taskExcerpt": "Recorte da questão",
      "noImageAvailable": "Nenhuma imagem disponível...",
      "masterSolution": "Solução-modelo",
      "aiGeneratedProposalTooltip": "Sugestão gerada por IA",
      "aiGeneratedProposal": "Sugestão gerada por IA",
      "review": "Revisar",
      "approvalRequiresPoints": "A aprovação só é possível quando a pontuação for maior que 0.",
      "saveRequiresPoints": "Salvar só é possível quando a pontuação for maior que 0.",
      "enterMasterSolution": "Digite a solução-modelo aqui...",
      "noMasterSolutionYet": "Nenhuma solução-modelo disponível ainda...",
      "gradingScheme": "Critérios de avaliação",
      "maxPoints": "Pontos máximos",
      "maxPointsValue": "Pontos máx.: {{points}}",
      "enterGradingScheme": "Digite os critérios de avaliação aqui...",
      "noGradingSchemeYet": "Nenhum critério de avaliação disponível ainda...",
      "gradingSchemeRefining": "Atualizando os critérios de avaliação...",
      "masterSolutionRefining": "Atualizando a solução-modelo..."
    },
    "submissionCheck": {
      "pageShort": "Pág. {{page}}",
      "zoomPage": "Ampliar página {{page}}",
      "pageAlt": "Página",
      "loading": "Carregando...",
      "newStudent": "Novo aluno",
      "readOnly": "Apenas leitura",
      "saving": "Salvando...",
      "saved": "Salvo",
      "unsavedUnassigned": "Não salvo – páginas não atribuídas",
      "unsavedUnassignedHint": "Arraste todas as páginas não atribuídas para um aluno e o salvamento será automático.",
      "saveFailed": "Não salvo – erro",
      "saveFailedHint": "Falha ao salvar. Será tentado novamente na próxima alteração ou ao fechar.",
      "reloaded": "Recarregado",
      "reloadedHint": "As entregas foram alteradas nesse meio-tempo. A atribuição salva foi recarregada.",
      "unassignedPagesTitle": "Necessita esclarecimento: Páginas não atribuídas ({{count}})",
      "unassignedPagesHint": "Por favor, arraste estas páginas para as pastas dos alunos.",
      "newStudentIndexed": "Novo aluno {{index}}",
      "studentIndexed": "Aluno {{index}}",
      "enterName": "Digite o nome...",
      "pageX_one": "{{count}} página",
      "pageX_other": "{{count}} páginas",
      "splitConfidenceHover": "Confiança de divisão: {{percent}}%",
      "splitPercent": "Divisão {{percent}}%",
      "deleteStudent": "Excluir aluno",
      "dragHint": "Arraste os documentos aqui para atribuí-los a {{name}}",
      "assignmentNotes": "Notas de atribuição",
      "previewPageAlt": "Visualização da página {{page}}",
      "pageCurrentOfTotal": "Página {{current}} de {{total}}",
      "locked": "Confirmado",
      "lockedHint": "Já confirmado – não pode mais ser editado."
    },
    "summary": {
      "studentsOverview": "Resumo por aluno",
      "studentsOverviewDesc": "Pontuação detalhada e avaliação da IA por questão",
      "searchStudent": "Buscar nome do aluno...",
      "student": "Aluno",
      "pointsAbbr": "P.",
      "total": "Total",
      "percentage": "Porcentagem",
      "grade": "Nota",
      "noHits": "Nenhum resultado encontrado.",
      "aiConfidenceHover": "Confiança da IA: {{percent}}% - Por favor, verifique manualmente",
      "aiUncertainties": "Incertezas da IA",
      "aiUncertaintiesDesc": "Revise os casos em que a IA está insegura para garantir avaliações justas.",
      "openDecisions": "{{count}} decisões pendentes",
      "sortBy": "Ordenar por",
      "task": "Questão",
      "aiUncertainty": "Incerteza da IA",
      "confidence": "Confiança da IA:",
      "points": "Pontos:",
      "toGrading": "Ir para a correção",
      "confirmed": "Confirmado",
      "confirm": "Confirmar",
      "noClarificationNeeded": "Nenhum esclarecimento necessário.",
      "worstAvg": "Pior média",
      "noDataYet": "Nenhum dado ainda",
      "avgSuffix": "em média",
      "frequentErrors": "Fontes de erro mais frequentes",
      "metricsPerTask": "Métricas por questão",
      "gradeDistribution": "Distribuição de notas",
      "count": "Quantidade",
      "pdfReports": "Relatórios em PDF",
      "downloadingPdf": "Gerando relatórios em PDF...",
      "downloadPdf": "Baixar relatórios em PDF",
      "csvExport": "Exportação de notas em CSV",
      "notConnected": "Ainda não conectado",
      "notMet": "Não cumprido",
      "downloadingCsv": "Gerando CSV...",
      "downloadCsv": "Baixar CSV",
      "gradeScale": "Escala de notas",
      "gradeFrom": "Nota {{grade}} a partir de",
      "normalDistribution": "Distribuição normal (Curva de Gauss)",
      "activated": "Ativado",
      "deactivated": "Desativado",
      "curveStrength": "Intensidade da curva",
      "curvingComingSoon": "O ajuste de curva ainda não está disponível. Este recurso chegará em breve.",
      "noSubmissionsFound": "Nenhuma entrega corrigida encontrada.",
      "avgPointsReached": "Ø Pontos obtidos",
      "pointsReached": "Pontos obtidos",
      "gradeSystem": "Sistema de notas",
      "gradeBorders": "Limites de notas",
      "lowestGradeLabel": "nota mais baixa (a partir de 0%)",
      "tabs": {
        "students": "Visão geral dos alunos",
        "clarification": "Necessita esclarecimento",
        "insights": "Insights das questões",
        "grades": "Distribuição de notas",
        "curving": "Escala de notas e curva",
        "export": "Exportar",
        "languageUse": "Domínio da língua & Gramática"
      },
      "gradingScales": {
        "german16": "Alemão (1–6)",
        "drittel": "Terços (1.0–5.0)",
        "af": "A–F",
        "gpa4": "GPA 4.0",
        "notenpunkte": "Pontos de nota (0–15)",
        "numeric10": "10 pontos",
        "percentage": "Porcentagem",
        "custom": "Personalizado"
      },
      "grammar": "Gramática",
      "fehlerindex": "Índice de erros (FI)",
      "grammarFiColumnHint": "Inclui apenas as tarefas ainda avaliadas pelo índice de erros; as tarefas avaliadas por regras têm colunas próprias.",
      "taskLanguageUseColumn": "{{label}} · Domínio da língua",
      "grammarTab": {
        "noGrammarTasks": "Este exame não contém tarefas com avaliação gramatical.",
        "fiTitle": "Dedução por índice de erros",
        "fiDesc": "Índice de erros = erros por 100 palavras. Ultrapassar os limites reduz a nota final em passos de nota.",
        "fiUnsupportedScale": "Não é possível deduzir passos de nota com uma escala percentual.",
        "fiAbove": "Se o índice de erros ultrapassar",
        "deductSteps": "deduzir (passos de nota)",
        "matrixTitle": "Erros gramaticais por aluno e tarefa",
        "matrixDesc": "Número de erros (índice de erros entre parênteses). Clicar numa célula abre a correção no modo gramática.",
        "fiSwitchTitle": "Aplicar índice de erros para este exame",
        "fiSwitchDesc": "Usa por padrão a sua definição de perfil; ative para substituir apenas neste exame.",
        "gradeWithFi": "Nota (com IE)"
      },
      "languageUseTab": {
        "rulesOverviewTitle": "Regras de domínio da língua utilizadas na avaliação",
        "ownRuleEntry": "{{label}}: regra própria ({{points}} pts)",
        "groupRuleEntry": "{{label}} ({{points}} pts)",
        "teacherRulesActive": "O domínio da língua é avaliado diretamente durante a correção segundo as suas regras pessoais. A dedução por índice de erros está desativada."
      }
    },
    "structureEditor": {
      "pointsInconsistent": "Os pontos não batem. Em cada nível, atribua pontos a todas as tarefas (cuja soma seja igual ao total da tarefa superior) ou deixe todas vazias. Corrija as tarefas destacadas:",
      "pointsInconsistentTask": "Faltam pontos na tarefa {{path}}",
      "totalPoints": "Pontos totais (incl. subtarefas)",
      "ownPoints": "Pontos próprios (a resposta própria desta tarefa)",
      "tasksWithoutRegion": "Tarefas sem região marcada",
      "noPages": "Nenhuma página disponível.",
      "taskAreasDetected_one": "{{count}} área de questão detectada",
      "taskAreasDetected_other": "{{count}} áreas de questões detectadas",
      "addArea": "Adicionar área",
      "remove": "Remover",
      "resetZoom": "Redefinir zoom",
      "readOnly": "Apenas leitura",
      "saving": "Salvando...",
      "saved": "Salvo",
      "blankExamPage": "Página da prova em branco {{page}}",
      "deleteBbx": "Excluir BBX",
      "retryOcr": "Repetir reconhecimento de texto",
      "noTasksOnPage": "Nenhuma questão nesta página",
      "task": "Questão",
      "noText": "Nenhum texto",
      "imageContent": "Imagem (sem reconhecimento de texto) - o recorte de imagem detectado será usado diretamente para processamento posterior",
      "additionalInfo": "Informação adicional",
      "noContent": "Nenhum conteúdo",
      "linkedTasks": "Questões vinculadas",
      "noTasks": "Nenhuma questão"
    },
    "demoSelector": {
      "title": "Selecionar demonstração",
      "description": "Escolha uma prova de exemplo. O gradias simulará o upload e iniciará a extração automaticamente.",
      "examCount_one": "{{count}} prova",
      "examCount_other": "{{count}} provas",
      "studentCount_one": "{{count}} aluno",
      "studentCount_other": "{{count}} alunos",
      "examLanguage": "Idioma da prova",
      "subjects": {
        "math": "Matemática",
        "english": "Inglês",
        "technical": "Escola técnica",
        "biology": "Biologia",
        "spanish": "Espanhol",
        "french": "Francês",
        "physics": "Física",
        "political_education": "Educação política",
        "german": "Alemão"
      },
      "grades": {
        "gesamtschule": "Escola Regular",
        "highSchool": "Liceu / Ensino Médio",
        "elementarySchool": "Ensino Fundamental / Básico",
        "vocationalSchool": "Ensino Profissional / Educação de Adultos",
        "middleSchool": "Ensino Fundamental II / Ciclo Intermediário",
        "university": "Universidade",
        "primarySchool": "Ensino Fundamental / Básico"
      },
      "exams": {
        "kaarst": {
          "name": "Análise de Funções (Matemática)",
          "description": "Conjunto de dados completo: entregas dos alunos, solução-modelo, critérios de avaliação e prova em branco"
        },
        "arne": {
          "name": "Frações - 6º Ano (Matemática)",
          "description": "Entregas dos alunos"
        },
        "lynehamMath": {
          "name": "Matemática",
          "description": "Entregas dos alunos"
        },
        "tuevBauleiter": {
          "name": "Mestre de Obras",
          "description": "Entregas dos alunos e solução-modelo"
        },
        "tuvPhotovoltaik": {
          "name": "Fotovoltaica",
          "description": "Entregas dos alunos e solução-modelo"
        },
        "engVocabulary": {
          "name": "Teste de Vocabulário (Inglês)",
          "description": "Conjunto de dados completo: entregas dos alunos, solução-modelo, critérios de avaliação e prova em branco"
        },
        "bioImageLabeling": {
          "name": "Rotulagem de Imagens (Biologia)",
          "description": "Conjunto de dados completo: entregas dos alunos, solução-modelo e prova em branco"
        },
        "mathProofFr": {
          "name": "Demonstração Matemática",
          "description": "Conjunto de dados completo: entregas dos alunos, solução-modelo e prova em branco"
        },
        "mathProofEng": {
          "name": "Demonstração Matemática",
          "description": "Conjunto de dados completo: entregas dos alunos, solução-modelo e prova em branco"
        },
        "plotting": {
          "name": "Desenho de Gráficos",
          "description": "Conjunto de dados completo: entregas dos alunos, solução-modelo e prova em branco"
        },
        "curveAnalysis": {
          "name": "Análise de Funções",
          "description": "Conjunto de dados completo: entregas dos alunos, solução-modelo e prova em branco"
        },
        "calculationDe": {
          "name": "Física",
          "description": "Conjunto de dados completo: entregas dos alunos, solução-modelo, critérios de avaliação e prova em branco"
        },
        "dictationFr": {
          "name": "Ditado — Francês",
          "description": "Conjunto de dados completo: entregas dos alunos, solução-modelo, critérios de avaliação e prova em branco"
        },
        "dictationEs": {
          "name": "Ditado — Espanhol",
          "description": "Conjunto de dados completo: entregas dos alunos, solução-modelo, critérios de avaliação e prova em branco"
        },
        "calculationFr": {
          "name": "Cálculo",
          "description": "Conjunto de dados completo: entregas dos alunos, solução-modelo, critérios de avaliação e prova em branco"
        },
        "calculationEs": {
          "name": "Cálculo",
          "description": "Conjunto de dados completo: entregas dos alunos, solução-modelo, critérios de avaliação e prova em branco"
        },
        "calculationEn": {
          "name": "Cálculo",
          "description": "Conjunto de dados completo: entregas dos alunos, solução-modelo, critérios de avaliação e prova em branco"
        },
        "multipleChoiceDe": {
          "name": "Múltipla escolha",
          "description": "Conjunto de dados completo: entregas dos alunos, solução-modelo, critérios de avaliação e prova em branco"
        },
        "multipleChoiceEn": {
          "name": "Múltipla escolha",
          "description": "Conjunto de dados completo: entregas dos alunos, solução-modelo, critérios de avaliação e prova em branco"
        },
        "multipleChoiceFr": {
          "name": "Múltipla escolha",
          "description": "Conjunto de dados completo: entregas dos alunos, solução-modelo, critérios de avaliação e prova em branco"
        },
        "multipleChoiceEs": {
          "name": "Múltipla escolha",
          "description": "Conjunto de dados completo: entregas dos alunos, solução-modelo, critérios de avaliação e prova em branco"
        },
        "politics12German": {
          "name": "Educação política — 12º ano",
          "description": "Conjunto de dados completo: entregas dos alunos, solução-modelo, critérios de avaliação e prova em branco"
        },
        "poetry12German": {
          "name": "Análise de poesia — 12º ano",
          "description": "Conjunto de dados completo: entregas dos alunos, solução-modelo, critérios de avaliação e prova em branco"
        },
        "poetry12English": {
          "name": "Análise de poesia — 12º ano",
          "description": "Conjunto de dados completo: entregas dos alunos, solução-modelo, critérios de avaliação e prova em branco"
        },
        "poetry12French": {
          "name": "Análise de poesia — 12º ano",
          "description": "Conjunto de dados completo: entregas dos alunos, solução-modelo, critérios de avaliação e prova em branco"
        },
        "materialBasedEnglish": {
          "name": "Redação baseada em materiais",
          "description": "Conjunto de dados completo: entregas dos alunos, solução-modelo, critérios de avaliação e prova em branco"
        },
        "materialBasedGerman": {
          "name": "Redação baseada em materiais",
          "description": "Conjunto de dados completo: entregas dos alunos, solução-modelo, critérios de avaliação e prova em branco"
        }
      }
    },
    "examEditor": {
      "savingAndRecompiling": "Salvando e recompilando…",
      "unsavedChanges": "Alterações não salvas",
      "allChangesSaved": "Todas as alterações salvas",
      "readOnlyBanner": "Este exame está em modo de leitura apenas: já existe uma solução modelo, um esquema de avaliação ou envios de alunos baseados na estrutura das tarefas, portanto não é mais possível fazer alterações aqui.",
      "generatingExam": "Gerando exame…",
      "refiningExam": "Atualizando exame…",
      "downloadPdf": "Baixar PDF",
      "confirmCreation": "Confirmar exame",
      "confirmingCreation": "A confirmar…",
      "confirmHint": "Confirme o exame para concluir a edição. O download e a entrega online só ficam disponíveis após esta confirmação final, e depois o exame já não poderá ser editado.",
      "confirmed": "Confirmado",
      "readOnly": "Apenas leitura",
      "confirmedBanner": "Este exame está confirmado e já não pode ser editado. O download e a entrega online estão disponíveis.",
      "confirmFailed": "Não foi possível confirmar o exame: {{message}}",
      "preparingPdf": "Preparando PDF…",
      "notSaved": "Não salvo: {{message}}",
      "seeProblemsBelow": "veja os problemas abaixo",
      "noExam": "Nenhuma prova.",
      "noSourceYet": "Esta prova ainda não tem fonte.",
      "noPreviewYet": "Ainda não há pré-visualização compilada — clique em qualquer bloco ou ponto para editar e gerar uma.",
      "tellAiPlaceholder": "Diga à IA o que alterar ...",
      "delete": "Excluir",
      "applying": "Aplicando …",
      "send": "Enviar",
      "done": "Concluído",
      "describeAiPlaceholder": "Descreva à IA qual tarefa adicionar aqui ...",
      "add": "Adicionar",
      "adding": "Adicionando …",
      "task": "Tarefa {{number}}",
      "taskNumber": "Número da tarefa",
      "type": "Tipo",
      "points": "Pontos",
      "lines": "Linhas",
      "taskText": "Texto da tarefa",
      "material": "Material",
      "title": "Título",
      "usedByTasks": "Usado pelas tarefas (números separados por vírgula)",
      "text": "Texto",
      "multipleChoice": "Múltipla escolha",
      "removeOption": "Remover opção",
      "addOption": "+ Adicionar opção",
      "figureProperties": "Propriedades da figura",
      "caption": "Legenda",
      "examSetup": "Configuração da prova",
      "subject": "Disciplina",
      "class": "Turma",
      "duration": "Duração",
      "totalPoints": "Pontuação total",
      "globalHints": "Dicas / instruções gerais",
      "studentView": "Preencher online"
    }
  },
  "TaskTypeDescs": {
    "taskFrame": "Agrupa subquestões, não requer uma resposta própria",
    "default": "Tipo de questão geral, usado quando nenhum outro se aplica",
    "shortText": "Resposta escrita curta (poucas frases)",
    "essay": "Texto dissertativo mais longo e estruturado",
    "diagram": "Desenho técnico, ex: fluxograma ou circuito elétrico",
    "sketch": "Desenho à mão livre ou esboço",
    "gapText": "Preenchimento de lacunas (texto lacunado)",
    "labelImage": "Rotular partes de uma imagem ou diagrama",
    "multipleChoice": "Selecionar a partir de opções fornecidas",
    "imageAnalysis": "Descrever ou interpretar uma imagem",
    "mapping": "Associar objetos/alternativas correspondentes",
    "legalCase": "Caso jurídico (estilo parecer)",
    "calculation": "Cálculo matemático ou físico",
    "mathematicalProof": "Demonstração matemática formal",
    "curveAnalysis": "Análise de funções (raízes, extremos, ...)",
    "plotting": "Plotar gráfico, função ou pontos no sistema de coordenadas",
    "geometry": "Construções ou cálculos geométricos (desenho)",
    "programming": "Escrever ou analisar código-fonte",
    "art": "Criar obra de arte ou design artístico",
    "dictation": "Escrever texto ditado",
    "translation": "Traduzir texto ou palavras para outro idioma",
    "chemicalFormula": "Equações ou fórmulas químicas",
    "music": "Ler ou escrever partituras musicais",
    "literaryAnalysisPoetry": "Analisar um poema",
    "analysisNonFiction": "Analisar um texto não ficcional",
    "materialBasedEssay": "Escrever uma redação com base em materiais fornecidos"
  },
  "TaskTypes": {
    "taskFrame": "Quadro da tarefa",
    "default": "Padrão",
    "shortText": "Texto curto",
    "essay": "Redação / Dissertação",
    "diagram": "Diagrama",
    "sketch": "Esboço",
    "gapText": "Texto lacunado",
    "labelImage": "Rotular imagem",
    "multipleChoice": "Múltipla escolha",
    "imageAnalysis": "Análise de imagem",
    "mapping": "Associação",
    "legalCase": "Caso jurídico",
    "calculation": "Cálculo",
    "mathematicalProof": "Demonstração matemática",
    "curveAnalysis": "Análise de funções",
    "plotting": "Plotar gráfico",
    "geometry": "Geometria",
    "programming": "Programação",
    "art": "Arte",
    "dictation": "Ditado",
    "translation": "Tradução",
    "chemicalFormula": "Fórmula química",
    "music": "Música",
    "literaryAnalysisPoetry": "Análise de poesia",
    "analysisNonFiction": "Análise de texto não ficcional",
    "materialBasedEssay": "Redação baseada em materiais"
  },
  "GapText": {
    "gap": "Lacuna",
    "correct": "Correto",
    "incorrect": "Incorreto",
    "empty": "Vazio",
    "points": "Pontos",
    "expectedAnswer": "Resposta esperada",
    "studentAnswer": "Resposta do aluno",
    "status": "Status"
  },
  "progress": {
    "analyzingSplit": "Analisando divisão",
    "extractingAnswers": "Extraindo respostas dos alunos...",
    "errorExtractingAnswers": "Erro ao extrair respostas dos alunos",
    "answersExtracted": "Respostas dos alunos extraídas",
    "extractingMasterSolution": "Extraindo conteúdos da solução-modelo",
    "errorStructureMasterSolution": "Erro ao criar estrutura de questões (solução-modelo)",
    "errorExtractingMasterSolution": "Erro ao extrair solução-modelo",
    "masterSolutionExtracted": "Solução-modelo extraída",
    "extractingGradingScheme": "Extraindo critérios de avaliação",
    "errorStructureGradingScheme": "Erro ao criar estrutura de questões (critérios de avaliação)",
    "errorExtractingGradingScheme": "Erro ao extrair critérios de avaliação",
    "gradingSchemeExtracted": "Critérios de avaliação extraídos",
    "noUsableMasterSolution": "Nenhum conteúdo útil de solução-modelo foi detectado. Por favor, verifique o arquivo ou ajuste a atribuição.",
    "noUsableGradingScheme": "Nenhum critério de avaliação útil foi detectado. Por favor, verifique o arquivo ou ajuste a atribuição.",
    "analyzingStructure": "Analisando estrutura da prova",
    "noSubmissions": "Nenhuma entrega disponível",
    "errorStructureAnalysis": "Erro na análise estrutural da prova",
    "noTasksInStructure": "Nenhuma questão encontrada na análise estrutural",
    "extractingTaskDescriptions": "Extraindo descrições das questões",
    "errorTaskDescriptions": "Erro ao extrair descrições das questões",
    "taskDescriptionsExtracted": "Descrições das questões extraídas",
    "taskStructureCreated": "Estrutura de questões criada",
    "waitingForStructureConfirmation": "Aguardando confirmação da estrutura da prova pelo usuário",
    "structureConfirmed": "Estrutura da prova confirmada",
    "structureConfirmationTimeout": "O tempo limite para confirmação da estrutura da prova expirou",
    "errorWaitingStructureConfirmation": "Erro ao aguardar a confirmação da estrutura da prova",
    "errorProcessingStructureConfirmation": "Erro ao processar a confirmação da estrutura da prova",
    "errorCreatingTaskStructure": "Erro ao criar estrutura de questões",
    "pipelineFailedPrematurely": "A pipeline falhou prematuramente",
    "assignmentConfirmed": "Atribuição confirmada",
    "gradingRunning": "Avaliação em andamento...",
    "gradingTaskX": "Avaliando questão {{taskNumber}} ...",
    "gradingCompleted": "Avaliação concluída",
    "gradingTaskXCompleted": "Avaliação da questão {{taskNumber}} concluída"
  },
  "upload": {
    "noExamId": "Nenhum ID de prova encontrado",
    "noFileSelected": "Nenhum arquivo selecionado",
    "processingFailed": "Não foi possível processar o arquivo",
    "invalidFileType": "Tipo de arquivo inválido. Por favor, selecione um arquivo PNG ou PDF.",
    "uploadError": "Erro ao enviar o arquivo",
    "studentName": "Aluno {{index}}",
    "noExamIdForReupload": "Erro: Nenhum ID de prova disponível para reenvio.",
    "reuploadCancelled": "SYSTEM INFO: Cancelamento de upload processado.",
    "reuploadCancelFailed": "SYSTEM INFO: Não foi possível processar completamente o cancelamento do upload.",
    "filesMissing": "SYSTEM BLOCK: Os seguintes arquivos não foram encontrados no armazenamento de upload: {{files}}. Certifique-se de que os nomes dos arquivos coincidam exatamente com os arquivos enviados.",
    "assignmentMismatch": "SYSTEM BLOCK: As seguintes atribuições de arquivos não coincidem com a última sugestão. Por favor, chame send_assignment_confirmation_message e confirme a nova atribuição com o usuário.\n{{lines}}",
    "reuploadStarted": "O reenvio dos arquivos foi iniciado em segundo plano. {{extra}}",
    "splitStarted": "A divisão foi iniciada para as entregas dos alunos.",
    "assignmentProposalSent": "Mensagem com sugestão de atribuição enviada.",
    "assignmentConfirmationMessage": "Ainda não tenho certeza sobre a atribuição dos arquivos e gostaria que você verificasse rapidamente.\n\nPor favor, confirme na área de arrastar e soltar se a atribuição sugerida está correta ou ajuste-a lá. Depois disso, poderei continuar imediatamente.",
    "assignmentProposalFallback": "Por favor, verifique minha sugestão de atribuição e confirme o vínculo dos arquivos.",
    "categorySubmissions": "Entregas dos alunos",
    "categoryMasterSolution": "Solução-modelo",
    "categoryGradingScheme": "Critérios de avaliação",
    "categoryBlankExam": "Prova em branco",
    "lowConfidenceListFormat": "'{{file}}' (planejado como {{category}})",
    "mismatchFormat": "- {{name}}: sugerido recentemente como \"{{proposed}}\", agora fornecido como \"{{supplied}}\""
  },
  "splitIssues": {
    "unknownStudent": "Aluno desconhecido",
    "studentNumber": "Aluno {{number}}",
    "pageAssignmentError": "Nem todas as páginas foram atribuídas exatamente uma vez",
    "nonConsecutive": "Páginas não consecutivas atribuídas para {{names}} (reordenação pelo agente)",
    "uncertainty": "Incerteza com {{names}}",
    "outlierLongExtremeSingle": "A entrega de {{names}} é extremamente longa",
    "outlierLongExtremePlural": "As entregas de {{names}} são extremamente longas",
    "outlierShortExtremeSingle": "A entrega de {{names}} é extremamente curta",
    "outlierShortExtremePlural": "As entregas de {{names}} são extremamente curtas",
    "outlierLongSingle": "A entrega de {{names}} é incomumente longa",
    "outlierLongPlural": "As entregas de {{names}} são incomumente longas",
    "outlierShortSingle": "A entrega de {{names}} é incomumente curta",
    "outlierShortPlural": "As entregas de {{names}} são incomumente curtas",
    "missingStudentNameSingle": "Não foi possível extrair o nome de {{missingCount}} de {{totalCount}} aluno",
    "missingStudentNamePlural": "Não foi possível extrair o nome de {{missingCount}} de {{totalCount}} alunos",
    "splitAgentFailure": "Erro do agente de divisão{{suffix}}",
    "errorPrefix": "Erro",
    "warningPrefix": "Aviso",
    "parseErrorFallback": "Não foi possível processar os dados. Por favor, verifique a atribuição no Canvas.",
    "messageError": "Encontrei {{count}} alunos com {{range}} páginas cada, mas ocorreu um problema na atribuição automática das páginas:\n{{problem}}\n\nPor favor, verifique a atribuição no Canvas correspondente e corrija-a manualmente, se necessário. Assim que terminar, confirme no chat ou pelo botão para que possamos continuar.",
    "messageWarning": "Encontrei {{count}} alunos com {{range}} páginas cada, mas existem os seguintes avisos:\n{{problem}}\n\nSe desejar, você pode verificar os avisos no Canvas de atribuição. Caso contrário, basta confirmar para podermos continuar.",
    "messageSuccess": "Encontrei {{count}} alunos com {{range}} páginas cada. A atribuição foi clara. Foi possível extrair o nome de todos os alunos. Por favor, confirme para podermos continuar.",
    "confirmationRequested": "Confirmação de divisão solicitada",
    "splitAgentFailed": "A atribuição automática das entregas dos alunos falhou. Por favor, tente o upload novamente mais tarde."
  },
  "structureIssues": {
    "pointsExplanation": "\n\n**Sobre os pontos:** Detectei pontos em algumas tarefas. Se você enviar um esquema de avaliação com a pontuação (ou já tiver enviado), os pontos serão retirados de lá; então você pode ignorar os pontos no canvas. Eles só são relevantes se o seu esquema de avaliação não os incluir ou se você quiser gerar um.\n\nRegras de pontuação: para cada tarefa, atribua pontos a todas as subtarefas diretas de modo que somem o total da tarefa superior, ou a nenhuma. Se você não atribuir pontos às subtarefas, mas apenas um total, a IA os distribuirá automaticamente ao gerar o esquema de avaliação.",
    "textCutoff": "Texto da questão incompleto",
    "missingInformation": "informações ausentes",
    "imageUnreadable": "Imagem ilegível",
    "task": "Questão",
    "mainTasks_one": "Detectei {{mainCount}} questão principal.",
    "mainTasks_other": "Detectei {{mainCount}} questões principais.",
    "mainAndSubTasks_one": "Detectei {{mainCount}} questões principais e {{subCount}} subquestão.",
    "mainAndSubTasks_other": "Detectei {{mainCount}} questões principais e {{subCount}} subquestões.",
    "intro": "### Identifiquei a seguinte estrutura de questões:\n\n{{countText}}",
    "problemsIntro": "\n\nOcorreram os seguintes problemas durante a detecção das questões: {{warnings}}. Por favor, observe as incertezas no Canvas, edite-as se necessário e confirme usando o botão ou no chat.",
    "uncertaintyIntro": "\n\nHá incertezas em {{labels}} durante a detecção das questões. Por favor, observe as incertezas no Canvas, edite-as se necessário e confirme usando o botão ou no chat.",
    "success": "\n\nNão ocorreram problemas durante a detecção das questões. Se desejar, você ainda pode dar uma olhada detalhada no Canvas; caso contrário, confirme usando o botão ou no chat."
  },
  "chatMessages": {
    "emptyState": "Inicie uma conversa digitando uma mensagem abaixo",
    "newMessage": "Nova mensagem",
    "cancel": "Cancelar",
    "send": "Enviar",
    "edit": "Editar",
    "editInCanvas": "Editar no Canvas",
    "confirmed": "Confirmado",
    "confirm": "Confirmar",
    "confirmAssignment": "Confirmar atribuição",
    "giveFeedback": "Enviar feedback",
    "feedbackTitle": "Enviar feedback",
    "feedbackDescription": "Diga-nos como podemos melhorar esta resposta.",
    "feedbackPlaceholder": "Seu feedback aqui...",
    "feedbackSubmit": "Enviar feedback",
    "submitAssignmentConfirmation": "Confirmo a divisão das páginas e a atribuição aos alunos. Por favor, continue.",
    "submitStructureConfirmation": "Confirmo a estrutura das questões",
    "studentSubmissions": "Entregas dos alunos",
    "masterSolution": "Solução-modelo",
    "gradingScheme": "Critérios de avaliação",
    "blankExam": "Prova em branco",
    "confirmedAssignmentIntro": "A atribuição de arquivos confirmada:",
    "assignmentIntro": "Atribuí os arquivos da seguinte forma. Por favor, verifique a atribuição e confirme-a:"
  },
  "AuthModal": {
    "loginError": "E-mail ou senha incorretos.",
    "signupFailed": "Falha no cadastro. Por favor, tente novamente.",
    "passwordMismatch": "As senhas não coincidem.",
    "forgotPasswordProblem": "Houve um problema. Por favor, tente novamente mais tarde.",
    "waitlistTitle": "Você está na lista!",
    "waitlistDesc": "Entraremos em contato assim que a próxima fase começar.",
    "waitlistInactive": "A lista de espera está desativada no momento.",
    "backToLogin": "Voltar para o login",
    "linkSentTitle": "Verifique sua caixa de entrada",
    "linkSentBody": "Se existir uma conta confirmada com este endereço de e-mail, você receberá em breve um link para redefinir sua senha. Ele é válido por 1 hora. Verifique também a pasta de spam. Não recebeu nenhum e-mail? Então cadastre-se.",
    "linkSentDesc": "Entendido",
    "linkSentRegister": "Ir para o cadastro",
    "forgotPasswordTitle": "Esqueceu sua senha?",
    "requestLink": "Solicitar link",
    "welcomeBack": "Bem-vindo de volta",
    "createAccount": "Criar conta",
    "emailLabel": "E-mail",
    "passwordLabel": "Senha",
    "forgotPasswordLink": "Esqueceu sua senha?",
    "loginButton": "Entrar",
    "firstNameLabel": "Nome",
    "lastNameLabel": "Sobrenome",
    "schoolLabel": "Escola",
    "subjectsLabel": "Disciplinas",
    "confirmPasswordLabel": "Confirmar",
    "signupButton": "Cadastrar",
    "registerHere": "Cadastre-se aqui",
    "loginHere": "Entre aqui",
    "continueGuest": "Continuar sem login →",
    "or": "ou",
    "continueWithGoogle": "Continuar com o Google",
    "roleTeacher": "Professor",
    "roleStudent": "Aluno",
    "emailNotVerified": "Confirme primeiro seu endereço de e-mail com o código que enviamos para:",
    "verifyEmailTitle": "Confirme seu endereço de e-mail",
    "verifyEmailDesc": "Enviamos um código de confirmação para:",
    "verifyEmailHint": "O código é válido por 15 minutos. Verifique também a pasta de spam.",
    "verifyEmailResend": "Enviar um novo código",
    "verifyEmailResent": "Enviamos um novo código para você.",
    "verifyEmailWrongAddress": "Endereço errado? Alterar",
    "verifyCodeLabel": "Código de confirmação",
    "verifyCodeButton": "Confirmar",
    "verifyCodeInvalid": "O código está incorreto.",
    "verifyCodeExpired": "O código expirou ou foi digitado incorretamente vezes demais. Solicite um novo código.",
    "changeRole": "Alterar função",
    "roleQuestion": "Você é professor ou aluno?",
    "passwordRequirements": "Pelo menos 8 caracteres, com letras maiúsculas e minúsculas, um número e um caractere especial.",
    "passwordInvalid": "A senha não atende aos requisitos.",
    "emailInvalid": "Informe um endereço de e-mail válido.",
    "googleNoAccount": "Ainda não existe uma conta para este endereço do Google. Cadastre-se primeiro."
  },
  "FeedbackPage": {
    "alerts": {
      "imageTooLarge": "A imagem \"{{name}}\" é grande demais (máx. 5MB).",
      "previewError": "Não foi possível gerar a visualização para {{name}}.",
      "submitError": "Algo deu errado. Por favor, tente novamente."
    },
    "success": {
      "title": "Muito obrigado pelo seu feedback!",
      "description": "Recebemos sua mensagem. Sua contribuição nos ajuda muito a melhorar o Gradias a cada dia.",
      "backButton": "Voltar para a prova"
    },
    "header": {
      "title": "Enviar feedback"
    },
    "content": {
      "description": "Notou um erro, tem uma ideia brilhante ou quer apenas nos dizer algo? Lemos todas as mensagens!"
    },
    "categories": {
      "title": "Sobre o que se trata?",
      "bug": {
        "title": "Erro / Bug",
        "desc": "Algo não está funcionando"
      },
      "feature": {
        "title": "Ideia / Sugestão",
        "desc": "Uma nova funcionalidade"
      },
      "general": {
        "title": "Outros",
        "desc": "Feedback geral"
      }
    },
    "message": {
      "title": "Sua mensagem",
      "placeholder": "Descreva seu problema ou sugestão com o máximo de detalhes possível..."
    },
    "upload": {
      "title": "Anexar captura de tela (Opcional)",
      "clickToSelect": "Clique para selecionar imagens",
      "formatConstraint": "PNG, JPG até no máximo 5MB por imagem",
      "attachedImages": "Imagens anexadas",
      "removeImage": "Remover imagem"
    },
    "submit": {
      "sending": "Enviando...",
      "send": "Enviar feedback"
    }
  },
  "ConfirmationReplies": {
    "split": {
      "confirmed": "A atribuição da prova e o número de alunos foram confirmados com sucesso. A extração da estrutura de questões já pode ser iniciada. Por favor, agradeça ao usuário pela confirmação da atribuição e informe no chat que a extração da estrutura de questões começará agora.",
      "pending": "A atribuição da prova e o número de alunos ainda não foram confirmados."
    },
    "structure": {
      "masterAndGrading": "A estrutura das questões foi confirmada com sucesso. A extração continua em segundo plano. Uma solução-modelo e critérios de avaliação já foram enviados e estão sendo processados em segundo plano. Agradeça brevemente ao usuário pela confirmação da estrutura e informe que a extração continuará. Sugira iniciar a correção.",
      "masterOnly": "A estrutura das questões foi confirmada com sucesso. A extração continua em segundo plano. Uma solução-modelo já foi enviada, mas os critérios de avaliação ainda estão faltando. Agradeça brevemente ao usuário pela confirmação da estrutura e informe que a extração continuará. Sugira criar critérios de avaliação baseados em IA como próximo passo.",
      "gradingOnly": "A estrutura das questões foi confirmada com sucesso. A extração continua em segundo plano. Os critérios de avaliação já foram enviados, mas a solução-modelo ainda está faltando. Agradeça brevemente ao usuário pela confirmação da estrutura e informe que a extração continuará. Sugira gerar uma solução-modelo baseada em IA.",
      "none": "A estrutura das questões foi confirmada com sucesso. A extração continua em segundo plano. A solução-modelo ainda está faltando. Agradeça brevemente ao usuário pela confirmação da estrutura, informe que a extração continuará e pergunte se, no próximo passo (assim que a extração terminar), ele gostaria que fosse gerada uma solução-modelo baseada em IA ou se prefere enviar uma solução-modelo usando o ícone de clipe de papel no campo de entrada. Mencione em sua resposta como o usuário pode enviar a solução-modelo, ou seja, usando o clipe de papel no campo de texto do chat."
    },
    "errors": {
      "notConfirmed": "Confirmation flag is false; nothing to do.",
      "missingIdentifiers": "Missing required identifiers for confirmation.",
      "missingSplitMessage": "Erro: Nenhuma mensagem de confirmação de divisão associada encontrada.",
      "missingStructureMessage": "Erro: Nenhuma mensagem de confirmação de estrutura associada encontrada.",
      "structureContentMissing": "Erro: Não foi possível carregar a mensagem de confirmação da estrutura.",
      "splitFailure": "Erro ao confirmar a divisão.",
      "structureFailure": "Erro ao confirmar a estrutura."
    }
  },
  "toolFallbackDesc": {
    "default": "Executar etapa da ferramenta",
    "set_metadata": "Metadados da prova",
    "create_exam": "Criar a prova agora",
    "generate_master_solution": "Criar solução-modelo agora",
    "refine_master_solution": "Refinar solução-modelo especificamente",
    "generate_grading_scheme": "Criar critérios de avaliação agora",
    "refine_grading_scheme": "Refinar critérios de avaliação especificamente",
    "run_grading_agent": "Executar avaliação",
    "set_task_score": "Definir pontuação manualmente",
    "open_canvas": "Abrir visualização em Canvas",
    "update_open_task_content": "Atualizar o texto da questão diretamente",
    "send_assignment_confirmation_message": "Solicitar confirmação da atribuição de arquivos",
    "process_files": "Processar arquivos enviados",
    "confirm_split_in_chat": "Confirmar atribuição no chat",
    "confirm_structure_in_chat": "Confirmar estrutura no chat",
    "confirm_exam_creation": "Confirmar exame",
    "query_exams": "Buscar dados da prova",
    "query_submissions": "Buscar entregas dos alunos",
    "get_available_options": "Buscar opções disponíveis",
    "get_task_types": "Buscar tipos de questões",
    "download_ms_gs": "Baixar solução-modelo / critérios de avaliação",
    "download_summary_reports": "Baixar relatório de avaliação",
    "save_teacher_memory": "Lembrar preferência",
    "get_teacher_memory": "Consultar preferências",
    "delete_teacher_memory": "Excluir preferências",
    "reprocess_errored_submissions": "Reprocessar entregas com erro",
    "change_settings": "Alterar configurações"
  },
  "Subjects": {
    "math": "Matemática",
    "physics": "Física",
    "chemistry": "Química",
    "biology": "Biologia",
    "history": "História",
    "geography": "Geografia",
    "english": "Inglês",
    "german": "Alemão",
    "french": "Francês",
    "spanish": "Espanhol",
    "computer_science": "Informática",
    "social_studies": "Estudos Sociais",
    "other": "Outros"
  },
  "ExamNotifications": {
    "newMessage": "Nova mensagem"
  },
  "LanguageUseTemplates": {
    "essay": "Níveis de desempenho · Desempenho na apresentação\n\n* excelente:\n  - O texto está estruturado de forma clara e lógica, com ligações eficazes entre as secções.\n  - A linguagem especializada é utilizada com segurança e precisão.\n  - As citações estão integradas corretamente e introduzidas em contexto; as referências incluem o número da linha.\n  - A sintaxe é variada, estilisticamente segura e adequada ao objeto literário.\n  - A gramática, a ortografia e a pontuação estão quase sem erros.\n* bom:\n  - O texto está estruturado de forma coerente.\n  - A linguagem especializada é utilizada, na maioria das vezes, com segurança.\n  - As citações são usadas de forma adequada e corretamente referenciadas.\n  - A sintaxe é correta e variada.\n  - Poucas infrações à gramática, à ortografia e à pontuação.\n* satisfatório:\n  - A estrutura é reconhecível, mas não é coerente de forma contínua.\n  - A linguagem especializada é utilizada de forma funcional, mas nem sempre precisa.\n  - São usadas citações, e as referências são, na maioria, corretas.\n  - A sintaxe é, na maioria, correta, por vezes monótona.\n  - As infrações à gramática, à ortografia e à pontuação não prejudicam a compreensão.\n* suficiente:\n  - A estrutura é reconhecível apenas de forma rudimentar.\n  - A linguagem especializada é utilizada apenas parcialmente ou de forma imprecisa.\n  - As citações são inconsistentes ou referenciadas de forma incompleta.\n  - A sintaxe é uniforme, com incertezas frequentes.\n  - A correção linguística é limitada; a compreensão é ocasionalmente dificultada.\n* deficiente:\n  - A apresentação é, em grande parte, desestruturada.\n  - A linguagem especializada está, em grande parte, ausente ou é utilizada incorretamente.\n  - As citações estão ausentes ou incorretas.\n  - As deficiências linguísticas prejudicam significativamente a compreensão.\n* insuficiente:\n  - A apresentação é tão deficiente que o trabalho é dificilmente compreensível.\n  - Os requisitos básicos de uma redação de interpretação literária escrita não são reconhecíveis.",
    "analysisNonFiction": "Níveis de desempenho · Desempenho na apresentação\n\n* excelente:\n  - O texto está estruturado de forma clara e lógica, com ligações eficazes entre as secções.\n  - A linguagem especializada é utilizada com segurança e precisão.\n  - As citações estão integradas corretamente e introduzidas em contexto; as referências incluem o número da linha.\n  - A sintaxe é variada, estilisticamente segura e adequada ao objeto literário.\n  - A gramática, a ortografia e a pontuação estão quase sem erros.\n* bom:\n  - O texto está estruturado de forma coerente.\n  - A linguagem especializada é utilizada, na maioria das vezes, com segurança.\n  - As citações são usadas de forma adequada e corretamente referenciadas.\n  - A sintaxe é correta e variada.\n  - Poucas infrações à gramática, à ortografia e à pontuação.\n* satisfatório:\n  - A estrutura é reconhecível, mas não é coerente de forma contínua.\n  - A linguagem especializada é utilizada de forma funcional, mas nem sempre precisa.\n  - São usadas citações, e as referências são, na maioria, corretas.\n  - A sintaxe é, na maioria, correta, por vezes monótona.\n  - As infrações à gramática, à ortografia e à pontuação não prejudicam a compreensão.\n* suficiente:\n  - A estrutura é reconhecível apenas de forma rudimentar.\n  - A linguagem especializada é utilizada apenas parcialmente ou de forma imprecisa.\n  - As citações são inconsistentes ou referenciadas de forma incompleta.\n  - A sintaxe é uniforme, com incertezas frequentes.\n  - A correção linguística é limitada; a compreensão é ocasionalmente dificultada.\n* deficiente:\n  - A apresentação é, em grande parte, desestruturada.\n  - A linguagem especializada está, em grande parte, ausente ou é utilizada incorretamente.\n  - As citações estão ausentes ou incorretas.\n  - As deficiências linguísticas prejudicam significativamente a compreensão.\n* insuficiente:\n  - A apresentação é tão deficiente que o trabalho é dificilmente compreensível.\n  - Os requisitos básicos de uma redação de interpretação literária escrita não são reconhecíveis.",
    "genericGroup": "Níveis de desempenho · Desempenho na apresentação\n\n* excelente:\n  - O texto está estruturado de forma clara e lógica, com ligações eficazes entre as secções.\n  - A linguagem especializada é utilizada com segurança e precisão.\n  - As citações estão integradas corretamente e introduzidas em contexto; as referências incluem o número da linha.\n  - A sintaxe é variada, estilisticamente segura e adequada ao objeto literário.\n  - A gramática, a ortografia e a pontuação estão quase sem erros.\n* bom:\n  - O texto está estruturado de forma coerente.\n  - A linguagem especializada é utilizada, na maioria das vezes, com segurança.\n  - As citações são usadas de forma adequada e corretamente referenciadas.\n  - A sintaxe é correta e variada.\n  - Poucas infrações à gramática, à ortografia e à pontuação.\n* satisfatório:\n  - A estrutura é reconhecível, mas não é coerente de forma contínua.\n  - A linguagem especializada é utilizada de forma funcional, mas nem sempre precisa.\n  - São usadas citações, e as referências são, na maioria, corretas.\n  - A sintaxe é, na maioria, correta, por vezes monótona.\n  - As infrações à gramática, à ortografia e à pontuação não prejudicam a compreensão.\n* suficiente:\n  - A estrutura é reconhecível apenas de forma rudimentar.\n  - A linguagem especializada é utilizada apenas parcialmente ou de forma imprecisa.\n  - As citações são inconsistentes ou referenciadas de forma incompleta.\n  - A sintaxe é uniforme, com incertezas frequentes.\n  - A correção linguística é limitada; a compreensão é ocasionalmente dificultada.\n* deficiente:\n  - A apresentação é, em grande parte, desestruturada.\n  - A linguagem especializada está, em grande parte, ausente ou é utilizada incorretamente.\n  - As citações estão ausentes ou incorretas.\n  - As deficiências linguísticas prejudicam significativamente a compreensão.\n* insuficiente:\n  - A apresentação é tão deficiente que o trabalho é dificilmente compreensível.\n  - Os requisitos básicos de uma redação de interpretação literária escrita não são reconhecíveis.",
    "materialBasedEssay": "Escrita baseada em materiais (redação de textos argumentativos / informativos)\n\nDesempenho de conteúdo e uso dos materiais (compreensão / estrutura textual):\n* A introdução é concisa, desperta o interesse do leitor e conduz ao tema (evitam-se transições clichê).\n* Reconhece-se uma estrutura coerente que corresponde a todos os elementos do tipo de texto exigido (por exemplo, comentário, ensaio, artigo).\n* O tema e a respetiva problemática são claramente delineados no início.\n* Os conceitos básicos importantes são explicados adequadamente sempre que necessário.\n* Todos os materiais fornecidos são considerados e integrados no texto de forma sensata e com correção de conteúdo.\n* Existe transparência quanto às afirmações de terceiros (citação correta, paráfrase e referência às fontes).\n* Distingue-se claramente entre a exposição dos factos, a argumentação e a avaliação pessoal.\n* A argumentação é ampla e diferenciada (considera vários aspetos do tema, bem como possíveis contra-argumentos).\n* Os argumentos individuais são convincentes para o público-alvo, claramente estruturados, explicados e sustentados com provas/exemplos.\n* Além dos argumentos retirados dos materiais, são apresentados argumentos próprios e conhecimentos especializados próprios.\n* A argumentação é reunida no final numa conclusão, eventualmente seguida de uma perspetiva de futuro.\n\nDesempenho linguístico e configuração textual (desempenho na apresentação):\n* A configuração linguística corresponde ao tipo de texto exigido, com linguagem clara, precisa e formulações próprias.\n* O vocabulário, o domínio dos termos especializados e o estilo funcional são precisos, diferenciados e estilisticamente adequados.\n* A construção das frases é controlável, variada e gramaticalmente complexa.\n* Erros normativos (de gramática, ortografia e pontuação) não prejudicam a fluidez da leitura.",
    "literaryAnalysisPoetry": "Desempenho na apresentação\n* 1. O examinando estrutura o seu texto de forma coerente, lógica, consistente e com clareza de pensamento:\n  - ponderação adequada das subtarefas na execução\n  - disposição estruturada e adequadamente ponderada do trabalho\n  - ligação coerente entre os diferentes passos de trabalho\n  - ligação de pensamento coerente entre as frases\n* 2. O examinando formula-se respeitando as exigências da linguagem especializada e da metodologia da disciplina:\n  - separação entre o nível da ação e o metanível\n  - relação fundamentada entre afirmações descritivas, interpretativas e avaliativas\n  - uso de terminologia especializada num contexto pertinente\n  - observância dos tempos verbais\n  - reprodução correta do discurso relatado (modalidade)\n* 3. O examinando fundamenta as suas afirmações através de citações adequadas e corretas:\n  - uso sensato de citações completas ou abreviadas com função argumentativa\n* 4. O examinando expressa-se com precisão linguística geral, segurança estilística e diferenciação conceptual:\n  - um estilo de escrita objetivo e distanciado\n  - um registo próprio da linguagem escrita\n  - capacidade de expressão conceptual abstrata\n* 5. O examinando formula com segurança lexical e sintática, de forma variada e complexa (e, ao mesmo tempo, clara).\n* 6. O examinando escreve com correção linguística."
  },
  "LatexEditor": {
    "insertFormula": "Fórmula",
    "insertFormulaHint": "Inserir uma nova fórmula na posição do cursor",
    "switchToRawLatex": "Mudar para LaTeX bruto",
    "switchToVisualEditor": "Mudar para o editor visual",
    "naturalLanguageHint": "Descreva esta fórmula em linguagem natural",
    "naturalLanguagePlaceholder": "ex.: \"integral de 0 a 10 de x²\"",
    "naturalLanguageError": "Falha na tradução. Tente novamente.",
    "insert": "Inserir",
    "removeFormula": "Remover fórmula",
    "cancel": "Cancelar"
  },
  "StudentExam": {
    "loading": "A carregar o teste…",
    "examFallbackTitle": "Teste",
    "classLabel": "Turma {{class}}",
    "namePlaceholder": "O teu nome",
    "answeredCount": "{{answered}} / {{total}} respondidas",
    "submit": "Entregar",
    "signInRequiredTitle": "Início de sessão necessário",
    "signInRequiredBody": "Inicia sessão para realizar este teste.",
    "signInAction": "Ir para o início de sessão",
    "unavailableTitle": "Indisponível",
    "submittedTitle": "Entregue",
    "submittedBody": "As tuas respostas foram guardadas e estão prontas para correção.",
    "errors": {
      "loadFailed": "Não foi possível carregar o teste.",
      "notFound": "Este teste não existe.",
      "notSignedIn": "Sessão não iniciada.",
      "noAccess": "Teste não encontrado ou sem acesso.",
      "noTasks": "Este teste ainda não tem tarefas.",
      "uploadedExam": "Este teste foi carregado em vez de criado, por isso não pode ser preenchido online.",
      "notConfirmed": "Este exame ainda não foi confirmado. Confirme-o no editor de exames (ou peça ao Gradi) antes de o preencher online.",
      "studentsOnly": "O preenchimento online está disponível apenas para contas de aluno.",
      "renderFailed": "Não foi possível apresentar o teste.",
      "unreadableAnswers": "Não foi possível ler as respostas.",
      "submitFailed": "Falha na entrega."
    },
    "canvas": {
      "undo": "Anular",
      "clear": "Limpar",
      "pen": "Caneta",
      "eraser": "Borracha",
      "redo": "Refazer",
      "zoom": "Desenhar ampliado",
      "zoomClose": "Fechar vista ampliada",
      "penWidth": "Espessura {{width}}"
    }
  }
}
